<ftr-search-bar
  [isMobile]="isMobile"
  [isTablet]="isTablet"
  [isDesktop]="isDesktop"
  [isSearching$]="isSearching$"
  [searchTerm$]="searchTerm$"
></ftr-search-bar>
<ftr-search-results-overlay
  *ngIf="isSearching$ | async"
  [isSearching$]="isSearching$"
  [searchType$]="searchType$"
  [searchTerm$]="searchTerm$"
  [searchResultsPageNumber$]="searchPage$"
></ftr-search-results-overlay>
